<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { isEmpty, clone } from 'lodash'
  import MultiSelectInput from '@/components/ui/MultiSelectInput'

  export default {
    name: 'SearchFilter',
    components: {
      MultiSelectInput,
    },
    props: {
      queryFilters: Object,
    },
    data() {
      return {
        isDisabled: true,
      }
    },
    computed: {
      ...mapState('users', ['filterOptions']),
      filters() {
        return this.queryFilters
      },
    },
    created() {
      this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case 'users/RESET_FILTER':
            this.onResetFilter()
            break
          default:
            return false
        }
      })

      if (isEmpty(this.filterOptions)) {
        this.getUserFilters()
      }

      if (!isEmpty(this.filters)) {
        this.isDisabled = false
      }
    },
    methods: {
      ...mapActions('users', [
        'resetFilter',
        'getUserFilters',
        'updateFilters',
      ]),
      onResetFilter() {
        this.$emit('onResetFilter')
        this.isDisabled = true
      },
      onResultUpdate(id, args) {
        this.$set(this.filters, id, args)
        this.updateFilters(clone(this.filters))

        if (!isEmpty(this.filters)) {
          this.isDisabled =
          Boolean(!(Object.values({ ...this.filters }).map(element => element.length).filter(item => item > 0)).length)
        }
      },
    },
  }
</script>
